module.exports = __webpack_public_path__ + "img/link_transparent.22370387.svg";